import React from 'react';

const FormationCard = ({ title, category, image }) => (
  <div className="formation-card">
    <h3 className="formation-title">{title}</h3>
    <p className="formation-category">{category}</p>
  </div>
);

export default FormationCard;